<div class="align_items_center flex_column gap_large padding_large" [class]="wrapper_classes" tabindex="0">
	<img [src]="img_src" aria-hidden="true">

	<div class="flex_column align_items_center">
		<h4 class="color_black_inactive text_align_center">
			{{ caption }}
		</h4>
		<a [routerLink]="route" class="block h4 margin_top_very_small text_align_center fw500" *ngIf="route && linkCaption">
			{{ linkCaption }}
		</a>
	</div>
</div>